import React, { Component } from 'react';
import Main from './Main'

class AppRoutes extends Component {
    render() {
        return (
            <div>
                <Main/>
            </div>
        );
    }
}

export default AppRoutes;